module.exports = __webpack_public_path__ + "img/hr-level1_idle.264f9ef7.png";